module.exports = __webpack_public_path__ + "media/images/powerpoint/kantar-public-background-db40dd14006c53d917f26d2afc3f17bb.png";